import type { Locale } from '../../i18n/core';
import { routeHref } from '../../routing/routes';
import { getInformationContent, type InformationPageName } from './content';

const escape = (value: string) => value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');

/** Render only shared source-owned policy copy; no user or network content enters here. */
export function renderInformationPage(page: InformationPageName, locale: Locale, basePath = ''): string {
  const content = getInformationContent(page, locale);
  return `<article class="information-page">
    <header class="information-heading"><p class="eyebrow">DesignForge</p><h1>${escape(content.title)}</h1><p>${escape(content.subtitle)}</p></header>
    <div class="information-body">
      ${content.sections.map(section => `<section><h2>${escape(section.title)}</h2>${section.paragraphs.map(paragraph => `<p>${escape(paragraph)}</p>`).join('')}</section>`).join('')}
      ${content.choices.length ? `<section><h2>${escape(content.choicesTitle)}</h2><ul>${content.choices.map(item => `<li><a href="${escape(item.href)}">${escape(item.label)}</a></li>`).join('')}</ul></section>` : ''}
      <aside class="information-contact"><h2>${escape(content.contactTitle)}</h2><a href="mailto:${escape(content.contactEmail)}">${escape(content.contactEmail)}</a></aside>
      <nav class="information-links" aria-label="${escape(content.navigationLabel)}">${content.navigation.map(item => `<a href="${escape(routeHref(item.view, undefined, undefined, basePath, locale))}">${escape(item.label)}</a>`).join('')}</nav>
    </div>
  </article>`;
}
